export default __webpack_public_path__ + "1bdb06c65c1c8c0cba32830c0ca444b1.gif";